(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-launcher-leia.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-launcher-leia.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const defaultResize = container => {
  if (!container) return;
  container.style.height = "".concat(window.innerHeight, "px");
  container.style.width = "".concat(window.innerWidth, "px");
};
const defaultListener = (eventName, eventData) => {
  dispatchEvent(new CustomEvent(eventName, {
    detail: eventData
  }));
};
const GameLauncherLeia = _ref => {
  let children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    gameSpecificParameters = _ref.gameSpecificParameters,
    _ref$onResize = _ref.onResize,
    onResize = _ref$onResize === void 0 ? defaultResize : _ref$onResize,
    _ref$listener = _ref.listener,
    listener = _ref$listener === void 0 ? defaultListener : _ref$listener;
  const gameContext = svs.ticketgames.ticketUtility.components.useGameContext();
  const startGameByLoader = svs.ticketgames.ticketUtility.components.startGameByLoader;
  const ticketInfo = gameContext.ticketInfo,
    _gameContext$isEInsta = gameContext.isEInstant,
    isEInstant = _gameContext$isEInsta === void 0 ? false : _gameContext$isEInsta,
    dispatch = gameContext.dispatch,
    launcherDispatch = gameContext.launcherDispatch;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.useSoundEnabled({
      ticketInfo
    }),
    soundEnabled = _svs$ticketgames$tick.soundEnabled;
  const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils.useAccessibilityStatus({
      isEInstant
    }),
    demoLoadingMsg = _svs$ticketgames$tick2.demoLoadingMsg;
  const HostChannel = svs.ticketgames.ticketUtility.utils.HostChannel;
  const gameRef = useRef(null);
  useEffect(() => {
    if (gameRef.current) {
      dispatch && dispatch({
        type: 'SET_GAME_REF',
        payload: gameRef
      });
    }
  }, [gameRef, dispatch]);
  useEffect(() => {
    const lazyOnResizeTicket = _.debounce(() => {
      gameRef.current && onResize(gameRef.current);
    }, 50);
    window.addEventListener('resize', lazyOnResizeTicket);
    return () => {
      window.removeEventListener('resize', lazyOnResizeTicket);
    };
  }, []);
  useEffect(() => {
    try {
      const onDone = launchParams => {
        gameloaderHelper.openGame(_objectSpread(_objectSpread({}, launchParams), {}, {
          hostChannel: new HostChannel({
            type: ticketInfo.gameEngineCode,
            name: ticketInfo.type,
            listener
          }),
          parentNode: gameRef.current
        }));
        onResize(gameRef.current);
      };
      startGameByLoader({
        gameSpecificParameters,
        gameContext,
        soundEnabled,
        onDone
      });
    } catch (error) {
      launcherDispatch({
        type: 'GAME_LAUNCHER_ERROR'
      });
    }
    return () => {
      var _gameloaderHelper, _gameloaderHelper$clo;
      (_gameloaderHelper = gameloaderHelper) === null || _gameloaderHelper === void 0 || (_gameloaderHelper = _gameloaderHelper.instance) === null || _gameloaderHelper === void 0 || (_gameloaderHelper$clo = _gameloaderHelper.close) === null || _gameloaderHelper$clo === void 0 || _gameloaderHelper$clo.call(_gameloaderHelper);
    };
  }, []);
  return React.createElement("div", {
    "aria-atomic": "true",
    "aria-label": "".concat(demoLoadingMsg),
    "aria-live": "polite",
    className: "default-game-launcher ".concat(className),
    ref: gameRef
  }, children);
};
setGlobal('svs.ticketgames.ticketUtility.components.GameLauncherLeia', GameLauncherLeia);

 })(window);